<template>
  <dialog-base
    :visible="visible"
    height="540"
    width="960"
  >
    <a
      class="dialog-video__close"
      href="javascript: void(0);"
      @click="close"
    ></a>
    <div
      :id="`video-detail-${$route.name}-${articleInfo.cardNo}`"
      class="dialog-video"
    ></div>
  </dialog-base>
</template>

<script>
import Txplayer from 'Txplayer';
import { mapGetters, mapActions } from 'vuex';
import { CONTENT_TYPE_MOVIE, CARD_INFO_PARAMS } from '@/constants/constant';
import EventBus from '@/common/Base';
import DialogBase from './Dialog';

export default {
  name: 'DialogVideo',
  components: {
    DialogBase
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.value
    };
  },
  computed: {
    ...mapGetters([
      'articleInfo'
    ])
  },
  watch: {
    value(val) {
      this.visible = val;
    }
  },
  mounted() {
    EventBus.$on('videoShow', async feed => {
      await this.getInfo(feed.cardNo);
      this.getPlayer();
    });
  },
  methods: {
    ...mapActions([
      'getCard',
      'getArticleInfoByJson'
    ]),
    close() {
      this.$emit('input', false);
      if (window.player) {
        window.player.destroy();
      }
    },
    async getInfo(cardNo) {
      await this.getArticleInfoByJson({
        navKey: 'shipin',
        cardNo
      });
      // await this.getCard({
      //   card_no: cardNo,
      //   ...CARD_INFO_PARAMS
      // });
    },
    getVid(url, vid = 'vid') {
      const urlSearch = url.split('?');
      const pstr = urlSearch[1].split('&');
      for (let i = pstr.length - 1; i >= 0; i--) {
        const tep = pstr[i].split('=');
        if (tep[0] === vid) {
          return tep[1];
        }
      }
      return false;
    },
    getPlayer() {
      const media = this.articleInfo.mediaList.find(item => item.mediaType === CONTENT_TYPE_MOVIE);
      const url = this.getVid(media.mediaUrl);
      const { name } = this.$route;
      window.player = new Txplayer({
        containerId: `video-detail-${name}-${this.articleInfo.cardNo}`,
        vid: url,
        width: '100%',
        height: '540px',
        autoplay: true,
        useSVG: true,
        showLogo: true,
        muted: false,
        volume: 50,
        settings: {
          UiControl: {
            subPlugins: [
              'UiControlPlay',
              'UiShowTime',
              'UiVolume',
              'UiProgress',
              'UiWindowFullScreen'
            ]
          }
        }
      });
      // 错误处理
      window.player.on('error', err => {
        // console.log(err);
      });
    }
  },
  beforeDestroy() {
    if (window.player) {
      window.player.destroy();
    }
    EventBus.$off('videoShow');
  }
};
</script>

<style lang="less" scoped>
.dialog-video {
  @icon_dialog_close: "~assets/icons/icon_dialog_close.svg";

  width: 100%;
  height: 540px;
  background-color: #000;
  &__close {

    top: 0;
    right: -42px;
    width: 32px;
    height: 32px;
    position: absolute;
    background: url(@icon_dialog_close) center no-repeat;
    background-size: cover;
  }
}
</style>
